<template>
  <div :style="styleObject" class="configuration">
    <br />
    <br />
    <br />
    <el-collapse>
      <el-card>
        <el-collapse-item title="首部" name="1">
          <div class="logoUp">
            <div class="logo">
              <div class="div">logo:</div>
              <el-upload
                class="avatar-uploader"
                action="/api/file/upload"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                accept="image/png, image/jpeg"
                name="uploadFile"
              >
                <img
                  v-if="data.companyDto.companyLogo"
                  :src="data.companyDto.companyLogo"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div class="logo">
              <div class="div">公司名称:</div>
              <el-input
                placeholder="请输入内容"
                v-model="data.companyDto.companyName"
                clearable
              ></el-input>
            </div>
          </div>
        </el-collapse-item>
      </el-card>
      <el-card @click.native="getmodmassage()">
        <el-collapse-item title="添加模板" name="2">
          <div style="display: flex;justify-content: flex-end;">
            <el-button
              type="primary"
              style="display:flex;border-radius: 10px 10px 0px 0px;"
              @click="add()"
              >添加模板</el-button
            >
          </div>
          <div class="table">
            <el-table :data="data.moduleListFindDtos">
              <el-table-column type="expand" width="100">
                <template slot-scope="scope">
                  <div class="chooseDiv">
                    <div
                      v-if="data.moduleListFindDtos[scope.$index].moduleModule"
                      class="chooseModule"
                    >
                      <one
                        @getModule="getModule(scope.$index, arguments)"
                        :openModule="data.moduleListFindDtos[scope.$index].data"
                        v-if="
                          data.moduleListFindDtos[scope.$index].moduleModule ===
                            1
                        "
                        ref="data"
                      ></one>
                      <two
                        @getModule="getModule(scope.$index, arguments)"
                        :openModule="data.moduleListFindDtos[scope.$index].data"
                        v-if="
                          data.moduleListFindDtos[scope.$index].moduleModule ===
                            2
                        "
                        ref="data"
                      ></two>
                      <three
                        @getModule="getModule(scope.$index, arguments)"
                        :openModule="data.moduleListFindDtos[scope.$index].data"
                        v-if="
                          data.moduleListFindDtos[scope.$index].moduleModule ===
                            3
                        "
                        ref="data"
                      ></three>
                      <four
                        @getModule="getModule(scope.$index, arguments)"
                        :openModule="data.moduleListFindDtos[scope.$index].data"
                        v-if="
                          data.moduleListFindDtos[scope.$index].moduleModule ===
                            4
                        "
                        ref="data"
                      ></four>
                      <five
                        @getModule="getModule(scope.$index, arguments)"
                        :openModule="data.moduleListFindDtos[scope.$index].data"
                        v-if="
                          data.moduleListFindDtos[scope.$index].moduleModule ===
                            5
                        "
                        ref="data"
                      ></five>
                    </div>
                    <div v-else style="text-align: center;">
                      请先选择模板
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="moduleName" label="模块名称">
                <template slot-scope="scope">
                  <el-input
                    v-model="data.moduleListFindDtos[scope.$index].moduleName"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="nameEnglish" label="模块英文">
                <template slot-scope="scope">
                  <el-input
                    v-model="
                      data.moduleListFindDtos[scope.$index].moduleEnglish
                    "
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="moduleModule" label="模块模板">
                <template slot-scope="scope">
                  <div style="display: flex;">
                    <el-select
                      ref="select"
                      v-model="
                        data.moduleListFindDtos[scope.$index].moduleModule
                      "
                    >
                      <el-option
                        v-for="(item, index) in options"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="moduleUrl" label="跳转地址">
                <template slot-scope="scope">
                  <el-input
                    v-model="data.moduleListFindDtos[scope.$index].moduleUrl"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="display" label="是否在顶部显示">
                <template slot-scope="scope">
                  <el-switch
                    v-model="data.moduleListFindDtos[scope.$index].display"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="age" label="操作">
                <template slot-scope="scope">
                  <el-button
                    style="border: 0px"
                    @click="deleteRow(scope.$index, scope.row)"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-collapse-item>
      </el-card>
      <el-card>
        <el-collapse-item title="底部" name="3">
          <div style="display: flex">
            <el-form :inline="true" :model="data" class="demo-form-inline">
              <el-form-item label="版权:">
                <el-input
                  v-model="data.companyDto.copyright"
                  placeholder="请输入版权"
                ></el-input>
              </el-form-item>
            </el-form>
            <el-form :inline="true" :model="data" class="demo-form-inline">
              <el-form-item label="ICP备案号:">
                <el-input
                  v-model="data.companyDto.icp"
                  placeholder="请输入ICP备案号"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <el-form :inline="true" :model="data" class="demo-form-inline">
              <el-form-item label="商务合作:">
                <el-input
                  v-model="data.companyDto.phone"
                  placeholder="请输入商务合作"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <el-form :inline="true" :model="data" class="demo-form-inline">
              <el-form-item label="公司地址:">
                <el-input
                  v-model="data.companyDto.address"
                  placeholder="请输入公司地址"
                >
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
      </el-card>
    </el-collapse>
    <!-- <el-button type="primary" @click="qwe()" style="margin-left: 230px"> -->
    <el-button type="primary" @click="onSubmit" style="margin-left: 230px">
      {{ buttonmsg }}
    </el-button>
  </div>
</template>

<script>
import axios from "axios";
import one from "./moduleOne/moduleOne.vue";
import two from "./moduleTwo/moduleTwo.vue";
import three from "./moduleThree/moduleThree.vue";
import four from "./moduleFour/moduleFour.vue";
import five from "./moduleFive/moduleFive.vue";
export default {
  data() {
    return {
      styleObject: {
        height: ""
      },
      id: 0,
      data: {
        companyDto: {},
        moduleListFindDtos: []
      },
      options: [
        {
          value: 1,
          label: "模板一"
        },
        {
          value: 2,
          label: "模板二"
        },
        {
          value: 3,
          label: "模板三"
        },
        {
          value: 4,
          label: "模板四"
        },
        {
          value: 5,
          label: "模板五"
        }
      ],
      buttonmsg: "",
      value: "",
      expands: [],
      num: 0
    };
  },
  components: {
    one,
    two,
    three,
    four,
    five
  },
  mounted() {
    this.innerHeight();
    this.getId();
    // this.rowDrop()
  },
  methods: {
    // qwe() {
    //   console.log(this.data.moduleListFindDtos, "1551");
    // },
    getId() {
      this.id = this.$route.query.id;
      if (this.id !== "0" && this.id !== 0) {
        this.buttonmsg = "修改";
        axios
          .get("/api/module/category?companyId=" + this.id, {})
          .then(res => {
            if (res.data.success) {
              this.data = res.data.data;
              console.log(this.data);
            }
          })
          .catch(res => {
            console.log(res.data);
          });
      } else {
        this.buttonmsg = "提交";
      }
    },
    getmodmassage() {
      if (this.num === 0) {
        if (
          this.data.moduleListFindDtos.length &&
          !(this.id === 0 || this.id === "0")
        ) {
          this.data.moduleListFindDtos.forEach(element => {
            if (element.moduleModule === 1) {
              axios
                .get("/api/banner/category?moduleId=" + element.id, {})
                .then(res => {
                  if (res.data.success) {
                    element.data = res.data.data.bannerDtos;
                    console.log(element.data, 12312312312312312312222222222);
                  }
                })
                .catch(res => {
                  console.log(res.data.errorMessage);
                });
            }
            if (element.moduleModule === 2) {
              axios
                .get("/api/about/category?moduleId=" + element.id, {})
                .then(res => {
                  if (res.data.success) {
                    element.data = res.data.data.aboutDtos;
                    console.log(element.data);
                  }
                })
                .catch(res => {
                  console.log(res.data.errorMessage);
                });
            }
            if (element.moduleModule === 3) {
              axios
                .get("/api/product/category?moduleId=" + element.id, {})
                .then(res => {
                  if (res.data.success) {
                    element.data = res.data.data.productFindDtos;
                  }
                })
                .catch(res => {
                  console.log(res.data.errorMessage);
                });
            }
            if (element.moduleModule === 4) {
              axios
                .get("/api/news/category?moduleId=" + element.id, {})
                .then(res => {
                  if (res.data.success) {
                    element.data = res.data.data.newsFindDtos;
                  }
                })
                .catch(res => {
                  console.log(res.data.errorMessage);
                });
            }
            if (element.moduleModule === 5) {
              axios
                .get("/api/join/category?moduleId=" + element.id, {})
                .then(res => {
                  if (res.data.success) {
                    element.data = res.data.data.joinFindAllDto;
                    console.log(element.data, "old element.data");
                    if (element.data[0].joinListFindDtos) {
                      element.data[0].joinListFindDtos.forEach(el => {
                        var a = JSON.parse(el.jobData);
                        console.log(a, "123");
                        el.name = a.name;
                        el.type = a.type;
                        el.content = a.content;
                        el.jobData = "";
                      });
                    }
                    console.log(element.data, "element.data");
                  }
                });
            }
          });
        } else {
          console.log(this.data.moduleListFindDtos, "11111111111????");
        }
      }
      this.num++;
    },
    // 获取高度
    innerHeight() {
      this.styleObject.height = window.innerHeight + "px";
      // console.log(this.styleObject.height)
    },
    handleAvatarSuccess(res) {
      this.data.companyDto.companyLogo = res.data.fileurl;
    },
    // 添加模块
    add() {
      this.data.moduleListFindDtos.push({
        moduleId: 0,
        moduleModule: "",
        data: []
      });
    },
    //窗口返回的值
    getModule(index, arg) {
      // console.log(arg, "arg");
      var p = arg[0];
      if (
        this.data.moduleListFindDtos[index].moduleModule === 3 ||
        this.data.moduleListFindDtos[index].moduleModule === 1 ||
        this.data.moduleListFindDtos[index].moduleModule === 4
      ) {
        this.data.moduleListFindDtos[index].data = p;
      } else if (
        this.data.moduleListFindDtos[index].moduleModule === 2 ||
        this.data.moduleListFindDtos[index].moduleModule === 5
      ) {
        this.data.moduleListFindDtos[index].data[0] = p;
        console.log(this.data.moduleListFindDtos[index].data, "6666 b>>A");
      }
    },
    deleteRow(index) {
      this.data.moduleListFindDtos.splice(index, 1);
      // console.log(row.number);
    },
    onSubmit() {
      console.log(this.data);

      if (this.id === 0 || this.id === "0") {
        axios
          .post("/api/module/add", {
            companyAddDto: this.data.companyDto,
            moduleListDtos: this.data.moduleListFindDtos
          })
          .then(res => {
            if (res.data.success) {
              console.log(this.data);
              window.history.back(-1);
            }
          })
          .catch(res => {
            console.log(res.data.errorMessage);
          });
      } else {
        axios
          .post("/api/module/modify", {
            ...this.data
          })
          .then(res => {
            if (res.data.success) {
              console.log("success");
              window.history.back(-1);
            }
          })
          .catch(res => {
            console.log(res.data.errorMessage);
          });
      }
    }
  }
};
</script>

<style lang="sass">
.configuration
  padding: 0 80px 0 80px
  legend
    margin-left: 20px
  .logoUp
    display: flex
    justify-content: space-around
    .logo
      display: flex
      padding: 20px 20px 0 20px
      line-height: 93px
      .div
        padding-right: 10px
        width: 32%
  .addmodule
    padding: 5px 0 0 20px
  .table
    .el-table__expanded-cell
      background-color: #fafafa
      .chooseDiv
        display: flex
        justify-content: center
      .chooseModule
        width: 75%
        .el-table , .el-table th , .el-table td
          background-color: #fafafa
          .el-input__inner
            background-color: #fdfdfd
  .el-form--inline .el-form-item__label
    width: 100px
  .avatar-uploader .el-upload
    border: 1px dashed #d9d9d9
    border-radius: 6px
    cursor: pointer
    position: relative
    overflow: hidden
    .avatar-uploader .el-upload:hover
      border-color: #409EFF
    .avatar-uploader-icon
      font-size: 28px
      color: #8c939d
      width: 100px
      height: 100px
      line-height: 100px
      text-align: center
    .avatar
      width: 100px
      height: 100px
      display: block
</style>
